module.exports = __webpack_public_path__ + "static/media/icon-senior-male.93a3121f.svg";